import type { Room } from '@studio/models/room';
import { depot } from '#~/depot/index.js';
import { getActiveStudioId, subscribeActiveStudio } from '#~/analytics/active-studio.js';
import { lambdaCorrelationScope } from './request-scope.js';

/** Bind request scope before requests start; every auth/room transition publishes a snapshot. */
export const startRequestScopeSync = (): (() => void) => {
  const sync = (): void => {
    const { user, roomRecords } = depot.getState();
    const studioId = getActiveStudioId();
    const room = studioId ? roomRecords[studioId as Room['id']] : undefined;
    const next = {
      userId: user?.id,
      organizationId: room?.organizationId ?? '',
      studioId,
      roomId: studioId
    };
    if (JSON.stringify(lambdaCorrelationScope.get()) !== JSON.stringify(next)) {
      lambdaCorrelationScope.set(next);
    }
  };
  const stopDepot = depot.subscribe(sync);
  const stopStudio = subscribeActiveStudio(sync);
  sync();
  return () => {
    stopDepot();
    stopStudio();
  };
};
